import goto from "./index";
import getStore from "@utils/redux/store";
import {
  hasPromoCode,
  hasVipPromoCode,
  isFastForwardEligible,
  isSupporterPlanEligible,
  isAddonStoreEligible,
} from "@utils/userSegment/features";

// This navigates outside of the Noom Premium context
export default {
  navigateFromNoomPremium(showEmailReminder = true) {
    const { purchasedNoomPremium } = getStore().getState();

    if (!hasPromoCode() && isFastForwardEligible()) {
      goto.fastForwardTrial({
        showEmailReminder:
          purchasedNoomPremium && showEmailReminder ? "noomPremium" : false,
      });
      return;
    }

    if (!hasVipPromoCode() && isSupporterPlanEligible()) {
      goto.layer("supporter-plan");
      return;
    }

    if (!hasVipPromoCode() && isAddonStoreEligible()) {
      goto.addOns({ forceReroll: true, showEmailReminder: false });
      return;
    }

    goto.enrollment({
      showEmailReminder: purchasedNoomPremium ? "noomPremium" : false,
    });
  },
};
